import React, { useState } from 'react';
import { Accordion,
    AccordionSummary,
    AccordionDetails,
    Paper, Box, Tooltip, Button, Chip } from '@mui/material';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import useApiManager from '../../../../utils/Api/apiManager';
import DeleteIcon from '@mui/icons-material/Delete';
import ConfirmationDialog from '../../../ConfirmationDialog/ConfirmationDialog';
import ContactsDialog from './ContactsDialog';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const DeleteRow = ({ hover }) => (
    <Box sx={{ position: 'relative', width: '20px', height: '22px' }}>
        {hover && <DeleteIcon />}
    </Box>
);

const Contacts = ({ data, fetchContacts, campaignId, contactsCount, fetchCampaignRelatedEntitiesCount }) => {
    const { del } = useApiManager();
    const [hoveredRow, setHoveredRow] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [openContactsDialog, setOpenContactsDialog] = useState(false);
    const [currentRow, setCurrentRow] = useState('');

    const handleContactsOpenDialog = () => {
        setOpenContactsDialog(true);
    };

    const handleContactsCloseDialog = () => {
        setOpenContactsDialog(false);
    };

    const handleOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleConfirmAction = () => {
        handleDelete();
        handleCloseDialog();
    };

    const handleDelete = async () => {
        try {
            const deletedRow = await del(`/leadcampaigns/${currentRow.id}/${campaignId}`);
            fetchContacts();
            fetchCampaignRelatedEntitiesCount();
        } catch (error) {
            console.error('Error unassigning:', error);
        }
    };

    const handleAddContacts = () => {
        handleContactsOpenDialog();
    };

    return (
        <div>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ArrowDropDownIcon />}
                    aria-controls="contacts-content"
                    id="contacts-header"
                    sx={{ px: 2 }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            width: '100%',
                            padding: '8px',
                        }}
                    >
                        <h4 sx={{ display: 'flex', alignItems: 'center', mb: 0, mt: 0 }}>
                            Contacts
                            {contactsCount > 0 && (
                                <Tooltip title={`Total Contacts: ${contactsCount}`} arrow>
                                    <Chip
                                        label={contactsCount}
                                        size="small"
                                        sx={{
                                            fontWeight: 'normal',
                                            fontFamily: 'Consolas, Menlo, Monaco, monospace',
                                            verticalAlign: 'middle',
                                            ml: 1
                                        }}
                                    />
                                </Tooltip>
                            )}
                        </h4>

                        <Box sx={{ display: 'flex', gap: 1 }}>
                            <Button
                                variant="contained"
                                onClick={(e) => {
                                    e.stopPropagation(); // Prevent accordion toggle
                                    handleAddContacts();
                                }}
                            >
                                Add New
                            </Button>
                        </Box>
                    </Box>
                </AccordionSummary>

                <AccordionDetails sx={{ pt: 0, px: 2, pb: 2 }}>
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} aria-label="contacts table">
                            <TableHead>
                                <TableRow>
                                    <TableCell width={10}>-</TableCell>
                                    <TableCell maxWidh={250}>Contact Name</TableCell>
                                    <TableCell>Email</TableCell>
                                    <TableCell>Phone</TableCell>
                                    <TableCell>Mobile</TableCell>
                                    <TableCell>Fax</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data?.map((row) => (
                                    <TableRow
                                        key={row.id}
                                        onMouseEnter={() => setHoveredRow(row.id)}
                                        onMouseLeave={() => setHoveredRow(null)}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <Tooltip title="Delete">
                                            <TableCell
                                                sx={{
                                                    width: '20px',
                                                    height: '22px',
                                                    padding: '8px',
                                                    cursor: 'pointer',
                                                }}
                                                onClick={() => {
                                                    setCurrentRow(row);
                                                    handleOpenDialog();
                                                }}
                                            >
                                                <DeleteRow hover={hoveredRow === row.id} />
                                            </TableCell>
                                        </Tooltip>
                                        <TableCell component="th" scope="row">
                                            <Link to={`/contacts/${row.id}`}>
                                                {row.firstName + ' ' + row.lastName}
                                            </Link>
                                        </TableCell>
                                        <TableCell>{row.email}</TableCell>
                                        <TableCell>{row.phone}</TableCell>
                                        <TableCell>{row.mobile}</TableCell>
                                        <TableCell>{row.fax}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </AccordionDetails>
            </Accordion>

            <ConfirmationDialog
                open={openDialog}
                title="Confirm Action"
                content="Are you sure you want to unassign this contact?"
                onClose={handleCloseDialog}
                onConfirm={handleConfirmAction}
                confirmText="Confirm"
                cancelText="Cancel"
            />

            <ContactsDialog
                open={openContactsDialog}
                setOpen={setOpenContactsDialog}
                campaignId={campaignId}
                fetchContacts={fetchContacts}
                fetchCampaignRelatedEntitiesCount={fetchCampaignRelatedEntitiesCount}
            />
        </div>
    )
}

export default Contacts;